import Utils from "@/common/utils/utils";

export const initDataPanelDetailTicket = (currentPanelInitDataRes, argsAll) => {
    let oldArgsAll = currentPanelInitDataRes.argsAll;

    if(oldArgsAll.currentAssigneeUserData && !Utils.isEmptyObject(oldArgsAll.currentAssigneeUserData)) {
        argsAll.setCurrentAssigneeUserData(oldArgsAll.currentAssigneeUserData);
    }
}